import axios from "axios";

const apiClient = axios.create({
  baseURL: "/api/speakToAConsultant",
  header: {
    "Content-Type": "application/json",
  },
});

const saveClientDetails = async (data) => {
  return apiClient.post("/", data);
};
export const speakToAConsultantService = {
  saveClientDetails,
};
